import colors from '../_shared/colors';

export default {
  contentContainer: `
    background-color: ${colors.lightBackground};
    padding: 20px;
    overflow: auto;
  `,
};
